"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLocation = exports.useSelectIsOpenPostPreview = exports.getIsMortgageCalcIconClicked = exports.getIsPageNotFound = exports.getIsShowHeaderActions = exports.useSelectRecentAddressSearch = exports.useSelectUserLocation = exports.useSelectSavedSearches = exports.useSelectToastMessages = exports.closePostPreview = exports.openPostPreview = exports.setIsMortgageCalcIconClicked = exports.setIsPageNotFound = exports.setIsShowHeaderActions = exports.removeFromSavedSearch = exports.saveSearchParams = exports.addToRecentAddressSearch = exports.setUserLocation = exports.clearToastMessages = exports.addToastMessage = exports.globalSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var lodash_1 = require("lodash");
var use_places_autocomplete_1 = require("use-places-autocomplete");
var RecentSearchManager_1 = require("../../utils/RecentSearchManager");
var SAVED_SEARHES_STOARGE_KEY = 'saved-searches';
var promptMessages = [];
var storageSavedSearches = localStorage.getItem(SAVED_SEARHES_STOARGE_KEY);
var initialState = {
    userLocation: null,
    toastMessages: promptMessages,
    recentAddrSearches: RecentSearchManager_1.RecentSearchManager.get(),
    savedSearches: storageSavedSearches ? JSON.parse(storageSavedSearches) : [],
    isShowHeaderActions: true,
    isPageNotFound: false,
    isMortgageCalcIconClicked: false,
    isOpenPostPreview: false,
};
exports.globalSlice = toolkit_1.createSlice({
    name: 'global',
    initialState: initialState,
    reducers: {
        setIsPageNotFound: function (state, action) {
            state.isPageNotFound = action.payload;
        },
        clearToastMessages: function (state) {
            state.toastMessages = [];
        },
        addToastMessage: function (state, action) {
            state.toastMessages.push(action.payload);
        },
        setUserLocation: function (state, action) {
            state.userLocation = action.payload;
        },
        addToRecentAddressSearch: function (state, action) {
            var inListAlready = -1;
            //Check if address data is already in the list
            state.recentAddrSearches.forEach(function (addr, index) {
                if (addr.place_id === action.payload.place_id) {
                    inListAlready = index;
                }
            });
            if (inListAlready >= 0) {
                state.recentAddrSearches.splice(inListAlready, 1);
            }
            state.recentAddrSearches.unshift(action.payload);
            if (state.recentAddrSearches.length > RecentSearchManager_1.MAX_RECENTS_COUNT) {
                state.recentAddrSearches.pop();
            }
            RecentSearchManager_1.RecentSearchManager.save(state.recentAddrSearches);
        },
        saveSearchParams: function (state, action) {
            state.savedSearches.unshift({
                timestamp: lodash_1.now(),
                params: action.payload,
            });
            localStorage.setItem(SAVED_SEARHES_STOARGE_KEY, JSON.stringify(state.savedSearches));
        },
        removeFromSavedSearch: function (state, action) {
            state.savedSearches.splice(action.payload, 1);
            localStorage.setItem(SAVED_SEARHES_STOARGE_KEY, JSON.stringify(state.savedSearches));
        },
        setIsShowHeaderActions: function (state, action) {
            state.isShowHeaderActions = action.payload;
        },
        setIsMortgageCalcIconClicked: function (state, action) {
            state.isMortgageCalcIconClicked = action.payload;
        },
        openPostPreview: function (state) {
            state.isOpenPostPreview = true;
        },
        closePostPreview: function (state) {
            state.isOpenPostPreview = false;
        },
    },
});
exports.addToastMessage = (_a = exports.globalSlice.actions, _a.addToastMessage), exports.clearToastMessages = _a.clearToastMessages, exports.setUserLocation = _a.setUserLocation, exports.addToRecentAddressSearch = _a.addToRecentAddressSearch, exports.saveSearchParams = _a.saveSearchParams, exports.removeFromSavedSearch = _a.removeFromSavedSearch, exports.setIsShowHeaderActions = _a.setIsShowHeaderActions, exports.setIsPageNotFound = _a.setIsPageNotFound, exports.setIsMortgageCalcIconClicked = _a.setIsMortgageCalcIconClicked, exports.openPostPreview = _a.openPostPreview, exports.closePostPreview = _a.closePostPreview;
var useSelectToastMessages = function (state) { return state.global.toastMessages; };
exports.useSelectToastMessages = useSelectToastMessages;
var useSelectSavedSearches = function (state) {
    return state.global.savedSearches;
};
exports.useSelectSavedSearches = useSelectSavedSearches;
var useSelectUserLocation = function (state) {
    return state.global.userLocation;
};
exports.useSelectUserLocation = useSelectUserLocation;
var useSelectRecentAddressSearch = function (state) { return state.global.recentAddrSearches; };
exports.useSelectRecentAddressSearch = useSelectRecentAddressSearch;
var getIsShowHeaderActions = function (state) {
    return state.global.isShowHeaderActions;
};
exports.getIsShowHeaderActions = getIsShowHeaderActions;
var getIsPageNotFound = function (state) {
    return state.global.isPageNotFound;
};
exports.getIsPageNotFound = getIsPageNotFound;
var getIsMortgageCalcIconClicked = function (state) {
    return state.global.isMortgageCalcIconClicked;
};
exports.getIsMortgageCalcIconClicked = getIsMortgageCalcIconClicked;
var useSelectIsOpenPostPreview = function (state) {
    return state.global.isOpenPostPreview;
};
exports.useSelectIsOpenPostPreview = useSelectIsOpenPostPreview;
exports.default = exports.globalSlice.reducer;
var getUserLocation = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var state, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.permissions.query({
                            name: 'geolocation',
                        })];
                case 1:
                    state = (_a.sent()).state;
                    if (state === 'denied') {
                        // @TODO: uncomment when we moved getUserLocation to app launch
                        /*dispatch(
                            addToastMessage({
                                text: "Banali doesn't have permissions to use your location",
                                appearance: 'warning',
                            })
                        );*/
                    }
                    else {
                        navigator.geolocation.getCurrentPosition(function (_a) {
                            var coords = _a.coords;
                            var latitude = coords.latitude, longitude = coords.longitude;
                            use_places_autocomplete_1.getGeocode({
                                location: new google.maps.LatLng(latitude, longitude),
                            }).then(function (data) {
                                data.forEach(function (suggestion) {
                                    if (suggestion.types.indexOf('sublocality_level_1') > -1) {
                                        var address_components = suggestion.address_components, geometry = suggestion.geometry, place_id = suggestion.place_id, formatted_address = suggestion.formatted_address;
                                        address_components.forEach(function (part) { });
                                        var formated = formatted_address.split(',');
                                        var main_text = formated.shift();
                                        var secondary_text = formated.join(', ');
                                        dispatch(exports.setUserLocation({
                                            geometry: geometry.viewport.toJSON(),
                                            formatted_address: formatted_address,
                                            address_components: address_components,
                                            place_id: place_id,
                                            main_text: main_text
                                                ? main_text
                                                : '',
                                            secondary_text: secondary_text,
                                            center: {
                                                lat: geometry.location.lat(),
                                                lng: geometry.location.lng(),
                                            },
                                        }));
                                    }
                                });
                            });
                        }, function (error) {
                            /* @TODO: Right now geting user location is attached to places autocomplete component
                                Thats why message is displaying seeral times.
                                - We need to get user location once at app launch
                                - Display messages accodingly on app launch
                                - Set default map position for search page if user allows us to get user location
                             */
                            // dispatch(
                            //     addToastMessage({
                            //         text: 'Something went wrong please trye later!',
                            //         appearance: 'error',
                            //     })
                            // );
                        }, {
                            maximumAge: 60000,
                            timeout: 5000,
                            enableHighAccuracy: true,
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getUserLocation = getUserLocation;
